import { useQuery } from '@tanstack/react-query';
import { requestSavedPaymentMethods, savedPaymentMethodsKey, selectDefaultPaymentMethod } from './paymentApi';

/**
 * The method the member's charges land on, for the Payment Center's default-method strip. Shares
 * the saved-methods query key, so mounting this alongside the Payment Accounts page or the one-time
 * payment picker costs no extra fetch, and "Set as default" already invalidates it.
 */
export function useDefaultPaymentMethod() {
  return useQuery({
    queryKey: savedPaymentMethodsKey,
    queryFn: requestSavedPaymentMethods,
    select: selectDefaultPaymentMethod,
  });
}
